import { useParams, useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { deleteBlog } from "./feature/blog.slice";
import { useToast } from "./context/ToastContext";

const BlogDetails = () => {
    const { id } = useParams();
    const blogs = useSelector((state) => state.blog.blogs);
    const blog = blogs.find(blog => String(blog.id) === id);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showToast } = useToast();

    const handleDelete = () => {
        if (window.confirm("Are you sure you want to delete this blog?")) {
            dispatch(deleteBlog(id));
            showToast('Blog deleted successfully', 'success');
            navigate('/');
        }
    }

    if (!blog) {
        return (
            <div className="text-center py-20">
                <h2 className="text-3xl font-bold text-slate-800 mb-4">Blog Not Found</h2>
                <p className="text-slate-500 mb-8">The blog you are looking for seems to have been removed.</p>
                <Link to="/" className="text-primary hover:underline font-medium">Back to Homepage</Link>
            </div>
        );
    }

    return (
        <div className="blog-details max-w-3xl mx-auto animate-fade-in-up">
            <article className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-slate-100 relative overflow-hidden">
                {/* Decoration */}
                <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-primary to-rose-400"></div>

                <header className="mb-10">
                    <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight">{blog.title}</h2>
                    <div className="flex items-center gap-4 text-sm text-slate-500 border-b border-slate-100 pb-8">
                        <div className="flex items-center gap-2">
                             <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center text-xl">
                                 👤
                             </div>
                             <div>
                                 <span className="block text-slate-400 text-xs uppercase tracking-wider font-semibold">Written by</span>
                                 <span className="text-primary font-bold text-base">{blog.author}</span>
                             </div>
                        </div>
                        <span className="ml-auto text-xs font-mono bg-slate-50 px-3 py-1 rounded-full border border-slate-100">
                            {blog.date ? new Date(blog.date).toLocaleDateString() : 'Unknown Date'}
                        </span>
                    </div>
                </header>

                <div className="text-lg text-slate-700 leading-8 mb-12 whitespace-pre-wrap font-serif">
                    {blog.body}
                </div>

                <div className="flex items-center gap-4 border-t border-slate-100 pt-8">
                    <Link 
                        to={`/edit/${id}`}
                        className="flex-1 bg-slate-100 text-slate-700 px-6 py-3 rounded-xl hover:bg-slate-200 transition-colors font-semibold text-center"
                    >
                        Edit Blog
                    </Link>
                    <button 
                        onClick={handleDelete} 
                        className="flex-1 bg-rose-50 text-rose-600 px-6 py-3 rounded-xl hover:bg-rose-100 transition-colors font-semibold text-center border border-rose-100"
                    >
                        Delete Blog
                    </button>
                </div>
            </article>
        </div>
    );
}

export default BlogDetails;